import type { GeoLocation } from '@smg-real-estate/geo-libs';

const INVENTORY_PROBE_SIZE = 0;

export type DirectoryInventoryFetcher = (params: {
  geoLocationIds: string[];
  size: number;
}) => Promise<{ total: number }>;

export async function geoLocationHasDirectoryInventory(
  geoLocationId: string,
  fetcher: DirectoryInventoryFetcher,
): Promise<boolean> {
  const { total } = await fetcher({
    geoLocationIds: [geoLocationId],
    size: INVENTORY_PROBE_SIZE,
  });

  return total > 0;
}

export async function filterGeoLocationsWithInventory(
  locations: GeoLocation[],
  fetcher: DirectoryInventoryFetcher,
): Promise<GeoLocation[]> {
  if (locations.length === 0) {
    return [];
  }

  const inventoryResults = await Promise.all(
    locations.map(async (location) => {
      const geoLocationId = location.newId ?? location.id;
      const hasInventory = await geoLocationHasDirectoryInventory(geoLocationId, fetcher);

      return hasInventory ? location : null;
    }),
  );

  return inventoryResults.filter((location): location is GeoLocation => location !== null);
}
